<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" persistent max-width="600px">
      <v-card>
        <v-card-title class="primary white--text">
          <span class="text-h5">Duplicar Aula</span>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-container>
            <ValidationObserver v-slot="{ handleSubmit }">
              <form @submit.prevent="handleSubmit(enableSubmit)">
                <v-row>
                  <v-col cols="12" class="py-2">
                    <div class="info-section">
                      <e-label class="font-weight-medium">Tipo de Aula</e-label>
                      <p class="font-weight-regular info-text">
                        {{ aulaDuplicada.tipo_de_aula }}
                      </p>
                    </div>
                  </v-col>

                  <v-col cols="12" sm="6" class="py-2">
                    <ValidationProvider name="Data" rules="required" v-slot="{ errors }">
                      <div class="date-picker-section">
                        <e-label>Selecione uma data</e-label>
                        <v-dialog
                          ref="dialog"
                          v-model="modal"
                          :return-value.sync="date"
                          width="290px"
                          desen
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              dense
                              v-model="dataFormatada"
                              prepend-inner-icon="mdi-calendar"
                              readonly
                              v-bind="attrs"
                              v-on="on"
                              hide-details
                              :error-messages="errors"
                              solo
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            color="primary"
                            v-model="dataAulaDuplicada"
                            scrollable
                            :allowed-dates="isAllowedDate"
                            locale="pt-BR"
                          >
                            <v-spacer></v-spacer>
                            <v-btn text color="error" @click="modal = false">Cancelar</v-btn>
                            <v-btn
                              text
                              color="primary"
                              @click="$refs.dialog.save(dataAulaDuplicada)"
                              >OK</v-btn
                            >
                          </v-date-picker>
                        </v-dialog>
                      </div>
                    </ValidationProvider>
                  </v-col>

                  <v-col
                    cols="12"
                    sm="6"
                    class="py-2"
                    v-if="aulaDuplicada.tipo_de_aula !== 'Aula Remota'"
                  >
                    <ValidationProvider name="Horário da aula" rules="required" v-slot="{ errors }">
                      <e-label>Selecione um horário</e-label>
                      <e-autocomplete
                        :items="horariosDisponiveis"
                        :error-messages="errors"
                        label="Horário"
                        :item-text="(item) => item.descricao"
                        v-model="horarioSelecionado"
                        prepend-inner-icon="mdi-clock-outline"
                        outlined
                        dense
                        hide-details
                        return-object
                        :disabled="!dataAulaDuplicada"
                      />
                    </ValidationProvider>
                  </v-col>
                </v-row>
                <v-divider class="my-4"></v-divider>
                <div v-if="aulaDuplicada.e_aula_infantil === 1">
                  <v-row>
                    <v-col cols="12" class="py-2">
                      <div class="info-section">
                        <e-label class="section-title"
                          >OBJETIVOS DE APRENDIZAGEM E DESENVOLVIMENTO</e-label
                        >
                        <div
                          class="info-content"
                          v-html="aulaDuplicada.objetivos_aprendizagem_desenvolvimento"
                        ></div>
                      </div>
                    </v-col>

                    <v-col cols="12" class="py-2">
                      <div class="info-section">
                        <e-label class="section-title">OBJETO DE ESTUDO</e-label>
                        <div class="info-content" v-html="aulaDuplicada.objeto_estudo"></div>
                      </div>
                    </v-col>

                    <v-col cols="12" class="py-2">
                      <div class="info-section">
                        <e-label class="section-title"
                          >ESTRATÉGIAS E AÇÕES / PRÁTICAS PEDAGÓGICAS</e-label
                        >
                        <e-label subheading>ACOLHIDA:</e-label>
                        <div class="info-content">{{ aulaDuplicada.acolhida }}</div>
                      </div>
                    </v-col>

                    <v-col cols="12" class="py-2">
                      <div class="info-section">
                        <e-label class="section-title">ATIVIDADES:</e-label>
                        <div class="info-content">{{ aulaDuplicada.atividade_classe }}</div>
                      </div>
                    </v-col>

                    <v-col cols="12" class="py-2">
                      <div class="info-section">
                        <e-label class="section-title">RECURSOS</e-label>
                        <div class="info-content">{{ aulaDuplicada.recursos }}</div>
                      </div>
                    </v-col>

                    <v-col cols="12" class="py-2">
                      <div class="info-section">
                        <e-label class="section-title">AVALIAÇÃO</e-label>
                        <div class="info-content">{{ aulaDuplicada.avaliacao }}</div>
                      </div>
                    </v-col>
                  </v-row>
                </div>

                <div>
                  <v-row>
                    <v-col cols="12" class="py-2">
                      <div class="info-section">
                        <e-label class="section-title">Conteúdo</e-label>
                        <div class="info-content" v-html="aulaDuplicada.conteudo"></div>
                      </div>
                    </v-col>

                    <v-col cols="12" class="py-2">
                      <div class="info-section">
                        <e-label class="section-title">Metodologia</e-label>
                        <div class="info-content">{{ aulaDuplicada.metodologia }}</div>
                      </div>
                    </v-col>
                  </v-row>
                </div>

                <template>
                  <v-row>
                    <v-col cols="12">
                      <v-alert color="primary" dense border="left">
                        <div class="font-weight-medium mb-2">Status de Preenchimento:</div>

                        <div class="d-flex align-center mb-1">
                          <v-icon :color="dataFormatada ? 'green darken-1' : 'grey'">
                            mdi-check-circle
                          </v-icon>
                          <span class="ml-2"
                            >Data da Aula
                            {{ dataFormatada ? "Selecionada" : "Não selecionada" }}</span
                          >
                        </div>

                        <div class="d-flex align-center mb-1">
                          <v-icon :color="horarioSelecionado ? 'green darken-1' : 'grey'">
                            mdi-check-circle
                          </v-icon>
                          <span class="ml-2"
                            >Horário
                            {{ horarioSelecionado ? "Selecionado" : "Não selecionado" }}</span
                          >
                        </div>

                        <v-progress-linear
                          :value="percentualPreenchido"
                          color="green"
                          height="20"
                          class="mt-4 mb-2"
                          rounded
                        >
                          <template v-slot:default="{ value }">
                            <strong>{{ Math.ceil(value) }}%</strong>
                          </template>
                        </v-progress-linear>
                      </v-alert>
                    </v-col>
                  </v-row>
                </template>

                <v-card-actions class="px-0">
                  <v-spacer></v-spacer>
                  <v-btn color="error" text @click="$emit('dialogChange', false)"> Cancelar </v-btn>
                  <v-btn
                    color="primary"
                    type="submit"
                    :loading="submittingForm"
                    :disabled="percentualPreenchido < 100"
                  >
                    Salvar
                  </v-btn>
                </v-card-actions>
              </form>
            </ValidationObserver>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <e-modal-confirm
      :confirmDialog="confirmDialog"
      :objectModal="objectModal"
      @changeModalConfirm="enableSubmit"
      @changeActionResponse="duplicarAula"
    />
  </v-row>
</template>

<script>
export default {
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    submittingForm: {
      type: Boolean,
      default: false,
    },
    form: {
      type: Object,
      required: true,
    },
    gestaoDeAulas: {
      type: Object,
      required: true,
    },
    horarios: {
      type: Array,
      required: true,
    },
    disciplinas: {
      type: Array,
    },
    datasPermitidas: {
      type: Array,
      required: false,
    },
  },
  data() {
    return {
      modal: false,
      aulaDuplicada: {},
      confirmDialog: false,
      dataAulaDuplicada: null,
      objectModal: {
        title: "Duplicar aula",
        message: "Tem certeza que deseja duplicar esta aula?",
      },
      horarioSelecionado: null,
      horariosDisponiveis: [],
      date: null,
    };
  },
  computed: {
    dataFormatada() {
      if (!this.dataAulaDuplicada) return null;
      const date = new Date(this.dataAulaDuplicada);
      return new Intl.DateTimeFormat("pt-BR", { timeZone: "UTC" }).format(date);
    },
    percentualPreenchido() {
      const totalCampos = 2;
      let preenchidos = 0;

      if (this.dataFormatada) preenchidos++;
      if (this.horarioSelecionado) preenchidos++;

      return (preenchidos / totalCampos) * 100;
    },
  },
  watch: {
    form: {
      immediate: true,
      handler(val) {
        this.aulaDuplicada = { ...val };
      },
    },
    dataAulaDuplicada(value) {
      if (value) {
        this.buscarHorariosDisponiveisPorData(value);
      } else {
        this.horariosDisponiveis = [];
        this.horarioSelecionado = null;
      }
    },
  },
  methods: {
    isAllowedDate(date) {
      if (!this.datasPermitidas || this.datasPermitidas.length === 0) return true;
      const diaSemana = new Date(date).getDay();
      return this.datasPermitidas.includes(diaSemana);
    },
    enableSubmit() {
      if (!this.dataAulaDuplicada) {
        this.$toast.warning("Por favor, selecione uma data válida");
        return;
      }

      if (this.aulaDuplicada.tipo_de_aula !== "Aula Remota" && !this.horarioSelecionado) {
        this.$toast.warning("Por favor, selecione um horário válido");
        return;
      }

      this.confirmDialog = true;
      this.aulaDuplicada.data = this.dataAulaDuplicada;
    },
    async duplicarAula() {
      this.$loaderService.open("Duplicando a Aula");
      try {
        const payload = {
          ...this.aulaDuplicada,
          horario_inicial: this.horarioSelecionado?.inicio || null,
          horario_final: this.horarioSelecionado?.final || null,
          horario_id: this.horarioSelecionado?.id || null,
          gestao_de_aula: parseInt(this.$route.params.gestaoDeAulaId, 10),
          disciplina_id: this.gestaoDeAulas.disciplina_id,
          turma_id: this.gestaoDeAulas.turma_id,
          instrutor_id: this.gestaoDeAulas.instrutor_id,
          data: this.dataAulaDuplicada,
        };

        await this.$services.aulasService.criar(payload);

        this.confirmDialog = false;
        this.$emit("dialogChange", false);
        this.$emit("aula-duplicada");
        this.$toast.success("Aula duplicada com sucesso!");
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.$loaderService.close();
      }
    },
    async buscarHorariosDisponiveisPorData(dataSelecionada) {
      const gestao_id = this.$route.params.gestaoDeAulaId;
      if (!gestao_id) {
        this.$toast.warn("Gestão de Aulas não definida");
        return;
      }

      try {
        const response = await this.$services.gestoesDeAulasService.listarHorarioDaGestao({
          gestao_id,
        });

        const horarios = response.payload.payload.horarios;

        const diasDaSemana = ["Segunda", "Terça", "Quarta", "Quinta", "Sexta", "Sábado", "Domingo"];
        const diaSemanaIndex = new Date(dataSelecionada).getDay();
        const nomeDia = diasDaSemana[diaSemanaIndex];

        this.horariosDisponiveis = horarios.filter(
          (h) => h.dia_semana.toLowerCase() === nomeDia.toLowerCase()
        );

        this.horarioSelecionado = null;
      } catch (error) {
        this.$handleError(error);
        this.horariosDisponiveis = [];
      }
    },
  },
};
</script>

<style scoped>
.info-section {
  margin-bottom: 16px;
}

.section-title {
  color: var(--v-primary-base);
  margin-bottom: 8px;
  font-size: 1rem;
}

.info-content {
  background-color: #f5f5f5;
  padding: 12px;
  border-radius: 4px;
  border-left: 3px solid var(--v-primary-base);
}

.info-text {
  padding: 8px 12px;
  background-color: #f5f5f5;
  border-radius: 4px;
}

.date-picker-section {
  margin-bottom: 16px;
}

.v-card__actions {
  padding: 16px 0 0 0;
}
</style>
